(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

(function ($) {
	'use strict';

	/**
  * Defines cookie active class. Added to `<body>` tag.
  * @var {String} 
  */

	var cookieActiveClass = 'has-cookie';

	/**
  * Creates a cookie.
  * @param {String}  name  The name of the cookie.
  * @param {String}  value The value of the cookie.
  * @param {Integer} days  The number of days to store the cookie for.
  */
	function createCookie(name, value, days) {
		var expires = "";
		if (days) {
			var date = new Date();
			date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
			expires = "; expires=" + date.toUTCString();
		}
		document.cookie = name + "=" + value + expires + "; path=/";
	}

	/**
  * Reads a cookie.
  * @param {String}  name  The name of the cookie.
  */
	function readCookie(name) {
		var nameEQ = name + "=";
		var ca = document.cookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1, c.length);
			}if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
		}
		return null;
	}

	/**
  * Erases a cookie.
  * @param {String}  name  The name of the cookie.
  */
	function eraseCookie(name) {
		createCookie(name, "", -1);
	}

	/**
  * Displays the cookie notification.
  */
	function showCookieNotification() {
		// Make sure cookie notification is displayed.
		$('.cookie-notification').show();
		// Add class to body for CSS styling.
		$('body').addClass(cookieActiveClass);
	}

	/**
  * Hides the cookie notification.
  */
	function hideCookieNotification() {
		// Make sure cookie notification is hidden.
		$('.cookie-notification').css('opacity', '0');
		// Add class to body for CSS styling.
		$('body').removeClass(cookieActiveClass);
	}

	/**
  * Initialize the cookie notification. 
  * Kicks things off.
  */
	function initCookieNotification() {

		// Only continue if there is no cookie set.
		if (!readCookie('cookie_notification')) {

			// Display the notification.
			showCookieNotification();

			// Add click event to notification button. 
			$('.cookie-notification__button button').click(function (e) {
				e.preventDefault();
				// Set the cookie with 'seen' value on click. Expire cookie after 1 year.
				createCookie('cookie_notification', 'seen', 365);
				// Hide the notification.
				hideCookieNotification();
			});
		}
	}

	/**
  * Waits until the document is loaded before kicking things off.
  */
	$(document).ready(function () {
		initCookieNotification();
	});
})(jQuery);

},{}]},{},[1])

